import { useState, useRef, useEffect } from 'react';

export const useElementHeight = () => {
    const ref = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (!ref.current) return;

        const observer = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.target === ref.current) {
                    setHeight(Math.round(entry.contentRect.height));
                }
            }
        });

        observer.observe(ref.current);

        return () => {
            observer.disconnect();
        };
    }, []);

    return { ref, height };
};
